import { render, staticRenderFns } from "./BaseFormLoading.vue?vue&type=template&id=6da5eed5&scoped=true&"
import script from "./BaseFormLoading.vue?vue&type=script&lang=js&"
export * from "./BaseFormLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da5eed5",
  null
  
)

export default component.exports